<template>
  <div class="dashboard">
    <SideNav v-bind:page_active="page_active" />

    <div class="main-section">
      <TopNav />

      <div class="content-body">
        <div class="row breadcrumb-area">
          <div class="col-lg-6">
            <h6>
              <a href="/wallet" title="Go back to Accounts"
                ><i class="fa fa-arrow-left text-dark"></i>
                &nbsp;&nbsp;&nbsp;&nbsp;Go Back </a
              ><br /><br />
              <b>Transfer Fund</b>
            </h6>
          </div>

          <div class="col-lg-6">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item"><a href="/dashboard">Home</a></li>
                <li class="breadcrumb-item"><a href="/wallet">Wallet</a></li>
                <li class="breadcrumb-item active" aria-current="page">
                  Transfer Fund
                </li>
              </ol>
            </nav>
          </div>
        </div>

        <div class="row mt-3 mb-5">
          <div class="col-lg-4">
            <form
              class="login-form card p-4"
              autocomplete="off"
              v-on:submit.prevent="handleTransfer"
              method="post"
            >
              <div class="form-group">
                <b>Transfer From:</b>
                <select
                  type="text"
                  autofocus
                  class="form-control select"
                  v-model="accounfundTransfer.sendersubaccountid"
                  required
                >
                  <option selected value="">Select Account</option>
                  <option
                    :class="
                      accounfundTransfer.receiversubaccountid ==
                      x.CustomerAccount
                        ? 'd-none'
                        : ''
                    "
                    v-for="x in subprofiles"
                    :key="x.CustomerAccount"
                    :value="x.CustomerAccount"
                    :style="
                      x.CustomerGroupId == 'TradeCash' ? '' : 'display:none'
                    "
                    >{{ x.CustomerAccount }} : &#x20A6;{{
                      thDFormat(Number(x.CreditRemaining))
                    }}</option
                  >
                </select>
              </div>
              <div class="form-group">
                <b>Transfer To:</b>
                <select
                  type="text"
                  autofocus
                  class="form-control select"
                  v-model="accounfundTransfer.receiversubaccountid"
                  required
                >
                  <option selected value="">Select Account</option>
                  <option
                    :class="
                      accounfundTransfer.sendersubaccountid == x.CustomerAccount
                        ? 'd-none'
                        : ''
                    "
                    v-for="x in subprofiles"
                    :key="x.CustomerAccount"
                    :value="x.CustomerAccount"
                    :style="
                      x.CustomerGroupId == 'TradeCash' ? '' : 'display:none'
                    "
                  >
                    {{ x.CustomerAccount }} : &#x20A6;{{
                      thDFormat(Number(x.CreditRemaining))
                    }}</option
                  >
                </select>
              </div>

              <div class="form-group">
                <b>Amount:</b>
                <input
                  required
                  type="text"
                  autocomplete="off"
                  autofocus
                  class="form-control"
                  placeholder="In Naira"
                  id="amount"
                  v-on:keyup="thFormat"
                  v-model="amount"
                />
              </div>
              <div class="form-group">
                <b>Pin:</b>
                <input
                  required
                  type="password"
                  oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');"
                  minlength="4"
                  maxlength="4"
                  autofocus
                  class="form-control"
                  placeholder="your Pin"
                  v-model="accounfundTransfer.secretpin"
                />
              </div>
              <div class="form-group">
                <b>Description:</b>
                <textarea
                  style="border: 1px solid #000;"
                  class="form-control"
                  placeholder="Description"
                  v-model="accounfundTransfer.description"
                ></textarea>
              </div>

              <div :class="msg_status" v-html="msg_content"></div>

              <button
                type="submit"
                class="btn form-control login-btn"
                :disabled="isDisabled"
              >
                {{ processBtn }}
              </button>
            </form>
          </div>
        </div>

        <Copyright />
      </div>
    </div>
  </div>
</template>

<script>
import SideNav from "@/components/SideNav.vue";
import Copyright from "@/components/Copyright.vue";
import TopNav from "@/components/TopNav.vue";
import axios from "axios";

export default {
  name: "TransferFund",
  components: {
    SideNav,
    TopNav,
    Copyright,
  },

  data() {
    return {
      page_active: "wallet",
      subprofiles: [],

      accounfundTransfer: {
        subaccountid: "",
        receiversubaccountid: "",
        sendersubaccountid: "",
        amount: 0,
        transactionreference: "09569065",
        description: "",
        secretpin: "",
      },
      amount: 0,

      isDisabled: false,
      processBtn: "TRANSFER",
      msg_status: "",
      msg_content: "",
      hasTransfer: false,
      isReauthenticated: false,
    };
  },

  watch: {
    $route: {
      immediate: true,
      handler() {
        document.title = "FMN | Fund Transfer";
      },
    },
  },

  mounted() {
    this.inactivityTime();
    if (this.$store.getters.vendor_no) {
      this.phone = this.$store.getters.phone;
      this.vendor_no = this.$store.getters.vendor_no;
      this.sub_acct = this.$store.getters.sub_acct;
    }

    this.subprofiles = this.$store.getters.subaccounts;

    // Check if there's a pending transfer session
    const pendingTransferSessionData = sessionStorage.getItem(
      "pendingTransferSession",
    );
    if (pendingTransferSessionData) {
      try {
        const sessionData = JSON.parse(pendingTransferSessionData);
        const currentToken = this.$store.getters.headerstoken;

        // Compare tokens - if different, user has been re-authenticated successfully
        if (sessionData.sessionToken !== currentToken) {
          // Tokens are different - proceed with transaction
          this.subprofiles = this.$store.getters.subaccounts;
          this.accounfundTransfer.sendersubaccountid =
            sessionData.senderAccount;
          this.accounfundTransfer.receiversubaccountid =
            sessionData.receiverAccount;
          this.amount = sessionData.amount;
          this.accounfundTransfer.description = sessionData.description;
          this.accounfundTransfer.secretpin = sessionData.secretpin;

          this.isReauthenticated = true;

          // Clear the pending session
          sessionStorage.removeItem("pendingTransferSession");

          // Show success message
          this.$swal.fire({
            title: "Welcome Back",
            text:
              "Your identity has been verified. Your transfer form has been pre-filled. Click TRANSFER to continue.",
            icon: "success",
            timer: 3000,
            timerProgressBar: true,
            showConfirmButton: false,
          });
        } else {
          // Tokens are the same - require re-authentication
          this.$swal
            .fire({
              title: "Additional Authentication Required",
              text:
                "For security purposes, you need to authenticate again to proceed with this transfer.",
              icon: "warning",
              showCancelButton: true,
              confirmButtonText: "Continue to Authentication",
              cancelButtonText: "Cancel",
              allowOutsideClick: false,
              allowEscapeKey: false,
            })
            .then((result) => {
              if (result.isConfirmed) {
                // Clear store and redirect to login
                this.$store.commit("logout");
                localStorage.clear();
                this.$router.push("/");
              } else {
                // User cancelled, clear the session
                sessionStorage.removeItem("pendingTransferSession");
              }
            });
        }
      } catch (err) {
        console.log("Error processing pending transfer session:", err);
        sessionStorage.removeItem("pendingTransferSession");
      }
    }

    // Check if redirected from login with verified session (legacy)
    const transferVerified = sessionStorage.getItem("transferVerified");
    if (transferVerified === "true") {
      try {
        const sessionData = JSON.parse(
          sessionStorage.getItem("transferSessionData"),
        );

        // Pre-fill the form with the stored transfer data
        this.accounfundTransfer.sendersubaccountid = sessionData.senderAccount;
        this.accounfundTransfer.receiversubaccountid =
          sessionData.receiverAccount;
        this.amount = sessionData.amount;
        this.accounfundTransfer.description = sessionData.description;
        this.accounfundTransfer.secretpin = sessionData.secretpin;

        // Set flag to indicate re-authentication is complete
        this.isReauthenticated = true;

        // Clear the session verification flags
        sessionStorage.removeItem("transferVerified");
        sessionStorage.removeItem("transferSessionData");

        // Show success message
        this.$swal.fire({
          title: "Welcome Back",
          text:
            "Your identity has been verified. Your transfer form has been pre-filled. Click TRANSFER to continue.",
          icon: "success",
          timer: 3000,
          timerProgressBar: true,
          showConfirmButton: false,
        });
      } catch (err) {
        console.log("Error restoring transfer session:", err);
        this.isReauthenticated = false;
      }
    }
    // this.fetchAccounts();
  },

  methods: {
    async handleTransfer() {
      try {
        // If already reauthenticated, execute the transfer
        if (this.isReauthenticated) {
          await this.handleTransferExecute();
          return;
        }

        // First submission - require re-authentication
        // Store the current session token and transfer data
        const sessionToken = this.$store.getters.headerstoken;
        const transferData = {
          sessionToken: sessionToken,
          timestamp: Date.now(),
          senderAccount: this.accounfundTransfer.sendersubaccountid,
          receiverAccount: this.accounfundTransfer.receiversubaccountid,
          amount: this.amount,
          description: this.accounfundTransfer.description,
          secretpin: this.accounfundTransfer.secretpin,
        };

        // Save to sessionStorage (clears when browser closes)
        sessionStorage.setItem(
          "pendingTransferSession",
          JSON.stringify(transferData),
        );

        // Show notification requiring additional authentication
        this.$swal
          .fire({
            title: "Additional Authentication Required",
            text:
              "For security purposes, you need to authenticate again to proceed with this transfer.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Continue to Authentication",
            cancelButtonText: "Cancel",
            allowOutsideClick: false,
            allowEscapeKey: false,
          })
          .then((result) => {
            console.log("SweetAlert result:", result);
            if (result.isConfirmed) {
              // Clear store and redirect to login
              this.$store.commit("logout");
              localStorage.clear();
              this.$router.push("/");
            } else {
              // User cancelled, clear the session
              sessionStorage.removeItem("pendingTransferSession");
            }
          });
      } catch (err) {
        console.log(err);
        this.msg_status = "alert alert-danger mt-4";
        this.msg_content = "An error occurred. Please try again.";
      }
    },

    async handleTransferExecute() {
      try {
        let frombal = this.$store.getters.subaccounts.filter(
          (el) =>
            el.CustomerAccount == this.accounfundTransfer.sendersubaccountid,
        )[0].CreditRemaining;

        this.msg_status = "";
        this.msg_content = "";

        this.accounfundTransfer.subaccountid = this.$store.getters.vendor_no;
        // this.accounfundTransfer.receiversubaccountid   = this.$store.getters.vendor_no;
        // this.accounfundTransfer.sendersubaccountid   = this.$store.getters.vendor_no;
        this.accounfundTransfer.amount = parseFloat(
          this.amount.replace(/,/g, ""),
        );
        this.accounfundTransfer.primary_legal_entity = this.$store.getters.entity;
        if (frombal >= this.accounfundTransfer.amount) {
          this.processBtn = "Loading...";
          this.isDisabled = true;

          let data = this.loadNew(this.accounfundTransfer);
          console.log(data);

          await axios({
            method: "post",
            url: this.$hostname + "/post-balances-between-subaccounts",
            headers: {
              "Content-Type": "application/json",
              "X-Request-IV": data.iv,
              Authorization: `Bearer ${this.$store.getters.headerstoken}`,
            },
            data: { token: data.cipher },
          })
            .then((res) => {
              let response = res.data;

              if (response.status == true) {
                this.accounfundTransfer = {
                  subaccountid: "",
                  receiversubaccountid: "",
                  sendersubaccountid: "",
                  amount: 0,
                  transactionreference: "09569065",
                  description: "",
                  secretpin: "",
                };
                this.amount = 0;

                this.fetchAccounts();

                this.msg_status = "alert alert-success mt-4";
                this.msg_content = response.message;
                this.isDisabled = false;
                this.processBtn = "TRANSFER";
                this.hasTransfer = true;
                this.isReauthenticated = false;
              } else {
                this.msg_status = "alert alert-danger mt-4";
                this.msg_content = response.message;
                this.isDisabled = false;
                this.processBtn = "TRANSFER";
                this.hasTransfer = false;
                this.isReauthenticated = false;

                if (response.reset) {
                  this.$swal
                    .fire("Alert", this.msg_content, "error")
                    .then((okay) => {
                      if (okay) {
                        window.location.href = "/reset-pin";
                      }
                    });
                } else {
                  this.$swal.fire("Alert", this.msg_content, "error");
                }
              }
            })

            .catch((error) => {
              console.log(error);
              if (error.response.status === 401) {
                this.is401(error.response.status);
              }
            })

            .finally((e) => {
              this.isDisabled = false;
              this.processBtn = "TRANSFER";
              console.log(e);
            });
        } else {
          this.$swal.fire("Alert", "Insufficient Fund!", "error");
        }
      } catch (err) {
        console.log(err);
      }
    },

    async fetchAccounts() {
      var loading_html = `
  <div style="display: flex; justify-content: center; align-items: center; height: 150px;">
    <div class="spinner-border" role="status" style="width: 4rem; height: 4rem; color: #006e40;">
      <span class="sr-only">Loading...</span>
    </div>
  </div>
`;
      this.$swal.fire({
        title: "",
        html: loading_html,
        showConfirmButton: false,
        showCancelButton: false,
      });

      try {
        let data = this.loadNew({
          vendor_no: this.$store.getters.vendor_no,
          primary_legal_entity: this.$store.getters.entity,
        });

        // Validate encrypted data before making request
        if (!data || !data.cipher) {
          console.error("Error: Encryption failed or cipher is empty", data);
          this.$swal.fire("Error", "Failed to encrypt request data", "error");
          return;
        }

        await axios({
          method: "get",
          url: this.$hostname + "/get-accounts-by-legal-entity",
          headers: {
            "Content-Type": "application/json",
            "X-Request-IV": data.iv,
            Authorization: `Bearer ${this.$store.getters.headerstoken}`,
          },
          params: { token: data.cipher },
        })
          .then((res) => {
            if (res.data.status == true) {
              this.$store.commit("set_subaccounts", res.data.data);

              let sub_acct = this.$store.getters.sub_acct;
              let newbal = res.data.data.filter(
                (el) => el.CustomerAccount == sub_acct,
              );
              this.$store.commit("set_sub_acct_bal", newbal[0].CreditRemaining);

              this.subprofiles = this.$store.getters.subaccounts;

              if (this.hasTransfer) {
                this.$swal.fire("Success Alert", this.msg_content, "success");
              } else {
                this.$swal.fire("Alert", this.msg_content, "error");
              }
            }
          })
          .catch((error) => {
            if (error.response.status === 401) {
              this.is401(error.response.status);
            }
          });
      } catch (err) {
        console.log(err);
        if (err.response.status === 401) {
          this.is401(err.response.status);
        }
      }
    },

    thFormat() {
      let num = parseFloat(this.amount.replace(/,/g, "")); //remove any currency format;
      isNaN(num)
        ? (this.amount = "")
        : (this.amount = Number(num).toLocaleString());
    },
  },

  beforeMount() {},

  created() {},
};
</script>

<style scoped>
.login-form input.form-control,
.select {
  margin: 0 0 24px 0px;
}
.form-group b {
  font-size: 12px;
}
</style>
